export const SUBMIT_USOBMODELS_ACTION_REQUESTED = "SUBMIT_USOBMODELS_ACTION_REQUESTED";
export const SUBMIT_USOBMODELS_ACTION_DISPATCHER =
  "SUBMIT_USOBMODELS_ACTION_DISPATCHER";
export const SUBMIT_USOBMODELS_ERROR_DISPATCHER = "SUBMIT_USOBMODELS_ERROR_DISPATCHER";
export const USOBMODELS_LOADING = "USOBMODELS_LOADING";

//Action Creator
export const submitUsobModelsAction = (data) => ({
  type: SUBMIT_USOBMODELS_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitUsobModelsActionDispatcher = (data) => ({
  type: SUBMIT_USOBMODELS_ACTION_DISPATCHER,
  payload: data,
});

export const submitUsobModelsErrorDispatcher = (data) => ({
  type: SUBMIT_USOBMODELS_ERROR_DISPATCHER,
  payload: data,
});

export const usobModelsLoading = (loading) => ({
  type: USOBMODELS_LOADING,
  payload: loading,
});
